import MagneticButton from './MagneticButton';
import Monolith from './Monolith';

type Props = {
  heading: string;
  sub?: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
};

export default function CtaBanner({
  heading,
  sub,
  primaryLabel = 'Book a Diagnostic',
  primaryTo = '/book',
  secondaryLabel,
  secondaryTo,
}: Props) {
  return (
    <section className="grain relative overflow-hidden bg-black py-32">
      <Monolith />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(201,169,110,0.07),transparent_65%)]"
      />
      <div className="container-x relative z-20 flex flex-col items-center text-center">
        <h2 className="max-w-3xl font-display text-section font-light text-white text-balance">
          {heading}
        </h2>
        {sub && (
          <p className="mt-6 max-w-xl font-sans text-body text-white/85">{sub}</p>
        )}
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <MagneticButton to={primaryTo}>{primaryLabel}</MagneticButton>
          {secondaryLabel && secondaryTo && (
            <MagneticButton to={secondaryTo} variant="ghost">
              {secondaryLabel}
            </MagneticButton>
          )}
        </div>
      </div>
    </section>
  );
}
